export default __webpack_public_path__ + "static/media/logo-white.da79bc9b.svg";